import { Route, Routes, Navigate } from 'react-router-dom';
import { useState } from 'react';
import jwt_decode from "jwt-decode";

import {
    Home,

    EditarDadosUsuarioLogado,

    IndexarDocumento,
    ConsultaDeDocumento,

    ListagemDeClienteDesativado,
    ListagemDeCliente,
    DetalheDeCliente,

    ListagemDeUnidadeDesativada,
    ListagemDeUnidade,
    DetalheDeUnidade,

    ListagemDeSetorDesativado,
    ListagemDeSetor,
    DetalheDeSetor,

    ConsultaDeCaixa,
    DetalheDeCaixa,

    ListagemDeUsuarioDesativado,
    ListagemDeUsuario,
    DetalheDeUsuario,

    ListagemDePerfilDesativado,
    ListagemDePerfil,
    DetalheDePerfil,

    ListagemDeTipo,
    DetalheDeTipo,
    EditarTipo,
    NovoTipo,

    ListagemDeIndiceDesativado,
    ListagemDeIndice,
    DetalheDeIndice,

    PaginaNaoEncontrada,
    CadastrarIndices,
    VisualizarDocumento,

    CodigoBarras,

} from '../pages';
import { } from '../pages/EditarDadosUsuarioLogado';
import { TJwtToken } from '../shared/services/api/usuario/auth/AuthService';
import { Api } from '../shared/services/api/axios-config';
import { GerarEtiqueta } from '../pages/Etiqueta/GerarEtiqueta';
import { Certificar } from '../pages/documento/Certificar';

export const AppRoutes = () => {
    const aux = Api.defaults.headers.common['Authorization'];
    var token = "";
    if (typeof aux === "string") {
        token = aux.split(" ")[1];
    }
    var decoded: TJwtToken = jwt_decode(token);

    const visao = decoded.role;
    const [alterarSenha] = useState(() => {return localStorage.getItem("AlterarSenha") === "true";});

    if(!!decoded.CNPJPadrao)
    {
        localStorage.setItem("cnpj", decoded.CNPJPadrao);
    }


    return (
        <Routes>
            {!alterarSenha ? (
                <>
                    {/* pra onde navegar quando não tiver a rota predefinida */}

                    <Route path='/home' element={<Home />} />
                    <Route path='/' element={<Navigate to="/home" />} />

                    <Route path='/404' element={<PaginaNaoEncontrada />} />
                    <Route path='/editarDados' element={<EditarDadosUsuarioLogado />} />

                    {visao !== "clienteFuncionario" && visao !== "zdocFuncionario" && (<>
                        <Route path='/*' element={<Navigate to="/404" />} />

                        <Route path='/usuario/desativado' element={<ListagemDeUsuarioDesativado />} />
                        <Route path='/usuario/detalhe/:idUsuario' element={<DetalheDeUsuario />} />
                        <Route path='/usuario' element={<ListagemDeUsuario />} />

                        <Route path='/perfil/desativado' element={<ListagemDePerfilDesativado />} />
                        <Route path='/perfil/detalhe/:idPerfil' element={<DetalheDePerfil />} />
                        <Route path='/perfil' element={<ListagemDePerfil />} />

                        <Route path='/documento/certificar' element={<Certificar />} />

                        {visao === "master" && (<>
                            <Route path='/*' element={<Navigate to="/404" />} />

                            <Route path='/cliente/desativado' element={<ListagemDeClienteDesativado />} />
                            <Route path='/cliente/detalhe/:cnpj' element={<DetalheDeCliente />} />
                            <Route path='/cliente' element={<ListagemDeCliente />} />
                            <Route path='/gerarEtiqueta' element={<GerarEtiqueta />} />
                            <Route path='/codigoBarras' element={<CodigoBarras />} />

                        </>)}

                        <Route path='/unidade/desativada' element={<ListagemDeUnidadeDesativada />} />
                        <Route path='/unidade/detalhe/:idUnidade' element={<DetalheDeUnidade />} />
                        <Route path='/unidade' element={<ListagemDeUnidade />} />

                        <Route path='/setor/desativado' element={<ListagemDeSetorDesativado />} />
                        <Route path='/setor/detalhe/:idSetor' element={<DetalheDeSetor />} />
                        <Route path='/setor' element={<ListagemDeSetor />} />

                        <Route path='/tipo/antigo/novo/:idTipo/:nomeTipo/:nivelUrl/:idSetor' element={<NovoTipo />} />
                        <Route path='/tipo/antigo/editar/:idTipo' element={<EditarTipo />} />
                        <Route path='/tipo/:editarOuNovo/:idTipo/:nomeTipo/:nivelUrl/:idSetor' element={<DetalheDeTipo />} />
                        <Route path='/tipo' element={<ListagemDeTipo />} />

                        <Route path='/indice/desativado' element={<ListagemDeIndiceDesativado />} />
                        <Route path='/indice/detalhe/:idIndice' element={<DetalheDeIndice />} />
                        <Route path='/indice' element={<ListagemDeIndice />} />

                        <Route path='/documento/certificar' element={<Certificar />}/>
                    </>)}
                    
                    <Route path='/caixa/detalhe/:idCaixa' element={<DetalheDeCaixa />} />
                    <Route path='/caixa' element={<ConsultaDeCaixa />} />

                    <Route path='/documento/indexar/:idCaixa/:localizador/:codigoBarras' element={<IndexarDocumento />} />
                    <Route path='/documento' element={<ConsultaDeDocumento />} />
                    <Route path='/documento/indices/:idCaixa' element={<CadastrarIndices />} />
                    <Route path='/documento/visualizar' element={<VisualizarDocumento />} />
                </>

            ) : (
                <>
                    {/* navegar para tela de edição sempre */}

                    <Route path='/*' element={<Navigate to="/editarDados" />} />
                    <Route path='/editarDados' element={<EditarDadosUsuarioLogado />} />
                </>
            )}

        </Routes>
    );
}